import * as ReactService from "@intech/react-service";
import { CalendarioPagamentoEntidade } from "../entidades/CalendarioPagamentoEntidade";

class CalendarioPagamento extends ReactService.BaseService {
  constructor() {
    super("CalendarioPagamento");
  }

  Listar = () =>
    this.CreateRequest<string[]>(ReactService.RequestType.GET, `Listar`);

  BuscarPorPlano = (cdplano: string) =>
    this.CreateRequest<CalendarioPagamentoEntidade[]>(ReactService.RequestType.GET, `BuscarPorPlano/${cdplano}`);

}

export const CalendarioPagamentoService = new CalendarioPagamento();
